import React, { useEffect, useState } from 'react'
import { getSingleFixture } from '../../../../api/api_football'

function SingleUtenlandsProffSummary({ fixture }) {
    const [requestCount, setRequestCount] = useState(0)
    const [fixtureDetails, setFixtureDetails] = useState(null)
    async function getFixtureDetails() {
        const fixtureDet = await getSingleFixture(fixture?.fixture_id)
        console.log(fixtureDet, 'SINGLE FIXTURE')
        setFixtureDetails(fixtureDet)
    }

    useEffect(() => {
        if (requestCount > 0 && requestCount < 2) {
            const date = new Date(fixture.event_date).getTime()
            const now = new Date().getTime()
            if (date > now) {
                console.log('FIXTURE IN FUTURE')
            } else {
                getFixtureDetails()
            }
        }
    }, [requestCount])

    function getTeamNameByTeamId(teamId, fixture) {
        let teamName = ''
        if (fixture?.homeTeam?.team_id && fixture?.awayTeam?.team_id) {
            if (fixture?.homeTeam?.team_id === teamId) {
                teamName = fixture.homeTeam.team_name
            } else {
                teamName = fixture.awayTeam.team_name
            }
        }
        console.log(teamName)
        return teamName
    }

    useEffect(() => {
        if (fixtureDetails) {
            const playerFixtureDetails = fixture?.players?.map((proff) => {
                const playerTeamName = getTeamNameByTeamId(
                    proff.team_id,
                    fixtureDetails
                )
                getPlayingTime(
                    playerTeamName,
                    proff.player_id,
                    proff.team_id,
                    fixtureDetails
                )
                getPlayerEvents(proff.player_id, fixtureDetails?.events)
                return proff
            })
        }
    }, [fixture, fixtureDetails])

    function getPlayingTime(teamName, playerId, teamId, fixture) {
        if (fixture?.lineups) {
            const lineUpTeam = fixture?.lineups[teamName]?.startXI?.filter(
                (player) => {
                    return player?.player_id === playerId
                }
            )
            const subsTeam = fixture?.lineups[teamName]?.substitutes?.filter(
                (player) => {
                    return player?.player_id === playerId
                }
            )
            if (subsTeam?.length > 0) {
                console.log('SUBSTITUTE')
            } else if (lineUpTeam?.length > 0) {
                console.log('STARTER')
            } else {
                console.log('NO DATA')
            }
            console.log(subsTeam, lineUpTeam, 'LINEUPS, SUBS')
        }
    }

    function getPlayerEvents(playerId, events) {
        const playerEvents = events?.filter((evnt) => {
            return evnt.player_id === playerId || evnt.assist_id === playerId
        })
        console.log(playerEvents, 'PLAYER EVENTS')
        return playerEvents
    }

    return (
        <div>
            <div>
                {fixture?.homeTeam?.team_name} - {fixture?.awayTeam?.team_name}{' '}
                <span>
                    <button
                        className={`btn btn-sm btn-${
                            requestCount > 0 && !fixtureDetails
                                ? 'danger'
                                : requestCount > 0 && fixtureDetails
                                ? 'success'
                                : 'light'
                        }`}
                        onClick={() =>
                            setRequestCount((requestCount) => requestCount + 1)
                        }
                    >
                        Hent detaljer
                    </button>
                </span>
            </div>
            <h4>Spillere:</h4>
            {fixture?.players?.map((player, index) => {
                return <p key={index}>{player?.player_name}</p>
            })}
        </div>
    )
}
export default SingleUtenlandsProffSummary
